import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NgClass } from '@angular/common';

import { IconComponent } from '@atoms/icon/icon.component';

@Component({
  selector: 'app-tag',
  imports: [NgClass, IconComponent],
  templateUrl: './tag.component.html',
  styleUrls: ['./tag.component.scss'],
})
export class TagComponent {
  @Input() color?: 'default' | 'primary' | 'secondary' = 'default';
  @Input() size: 'default' | 'large' = 'default';
  @Input() hover?: boolean;
  @Input() type?: 'check';
  @Input() close?: boolean;
  @Output() clicked: EventEmitter<void> = new EventEmitter<void>();
  @Output() closed: EventEmitter<void> = new EventEmitter<void>();

  click(): void {
    this.clicked.emit();
  }

  closeClick(): void {
    this.closed.emit();
  }
}
